var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-return-select-items flex flex-auto flex-col" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticClass: "select-all-card",
          class: { "highlighted-select-all-card": _vm.allSelected },
        },
        [
          _c("div", { staticClass: "select-all-text flex-auto" }, [
            _vm._v("\n      Select all\n    "),
          ]),
          _vm._v(" "),
          _vm.allSelected
            ? _c("AllReturnReasons", {
                attrs: { "return-reasons": _vm.returnReasons },
                on: { "selected-all-reason": _vm.setSelectedAllReason },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-checkbox", {
            on: { change: _vm.selectAll },
            model: {
              value: _vm.allSelected,
              callback: function ($$v) {
                _vm.allSelected = $$v
              },
              expression: "allSelected",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.selections, function (item) {
        return _c(
          "ReturnableOrderItemView",
          _vm._b(
            {
              key: item.id,
              attrs: {
                "is-selected": item.selected,
                "selected-reason": item.reason,
                selected: item.selected,
                reason: item.reason,
                "return-reasons": _vm.returnReasons,
                "all-selected": _vm.allSelected,
              },
              on: {
                "update:selected": function ($event) {
                  return _vm.$set(item, "selected", $event)
                },
                "update:reason": function ($event) {
                  return _vm.$set(item, "reason", $event)
                },
                uncheckSelectAll: _vm.uncheckSelectAll,
              },
            },
            "ReturnableOrderItemView",
            item,
            false
          )
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n      Select items you want to return\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n      Please select the items you would like to proceed with and add a return reason.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }